import apiClient from "../utils/apiUtils";

export const policyService = {
  // Get all policies
  getPolicies: async () => {
    const response = await apiClient.get("/company-policies");
    return response.data;
  },

  // Get single policy by ID
  getPolicy: async (id) => {
    const response = await apiClient.get(`/company-policies/${id}`);
    return response.data;
  },

  // Create new policy
  createPolicy: async (payload) => {
    const response = await apiClient.post("/company-policies", payload);
    return response.data;
  },

  // Update existing policy
  updatePolicy: async (id, payload) => {
    const response = await apiClient.put(`/company-policies/${id}`, payload);
    return response.data;
  },

  // Delete policy
  deletePolicy: async (id) => {
    const response = await apiClient.delete(`/company-policies/${id}`);
    return response.data;
  },
};

export default policyService;
